import React, { useEffect, useState } from 'react';

interface AnimatedSpriteProps {
    spriteUrl: string;
    frameCount?: number;
    frameWidth?: number;
    frameHeight?: number;
    duration?: number;
    isPlaying?: boolean;
    className?: string;
}

export const AnimatedSprite: React.FC<AnimatedSpriteProps> = ({
    spriteUrl,
    frameCount = 4,
    frameWidth = 292,
    frameHeight = frameWidth,
    isPlaying = true,
    className = '',
}) => {
    const [currentFrame, setCurrentFrame] = useState<number>(0);
    const [shouldUpdate, setShouldUpdate] = useState(true);

    useEffect(() => {
        if (!isPlaying) return;

        const interval = setInterval(() => {
            if (shouldUpdate) {
                setCurrentFrame(prev => {
                    const nextFrame = (prev + 1) % frameCount;
                    setShouldUpdate(false);
                    setTimeout(() => setShouldUpdate(true), 2000 + Math.random() * 1000);
                    return nextFrame;
                });
            }
        }, 100);

        return () => clearInterval(interval);
    }, [isPlaying, frameCount, shouldUpdate]);

    return (
        <div className={`${className} relative`}>
            <div
                className="bg-no-repeat w-full h-full"
                style={{
                    backgroundImage: `url(${spriteUrl})`,
                    backgroundPosition: `0 -${currentFrame * frameHeight}px`,
                    backgroundSize: `100% ${frameHeight * frameCount}px`,
                    transition: 'background-position-y 50ms steps(1)'
                }}
            />
        </div>
    );
};